/* RESPONSIBLE TEAM: team-inbox-management */
import { ParentAction } from './action';
export default class InsertTicketCard extends ParentAction {
  id = 'insert-ticket-card';
  icon = 'ticket' as const;
  paneComponent = 'inbox2/command-k/insert-ticket-card/pane';
}
